import src from "IMAGE";
export default { src, width: 4706, height: 785, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAIElEQVR42mOIAwJZINAHgkQgCAKCkJCQ0GAg0NXV1QEAkBMIxeqvUUIAAAAASUVORK5CYII="};
